export default function nearestParent(el: HTMLElement, className: string) {
    while (el && !el.classList.contains(className))
        el = el.parentElement

    return el;
}

export function nearestTagName(el: HTMLElement, tagName: string) {
    while (el && el.tagName.toLowerCase() !== tagName.toLowerCase())
        el = el.parentElement

    return el;
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/nearest-parent.ts